import { format as formatDate } from 'date-fns';

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  // Format: "Dec 15, 2024 at 2:30 PM"
  return formatDate(date, 'MMM dd, yyyy \'at\' h:mm a');
};

export const formatTime = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  // Format: "2:30 PM"
  return formatDate(date, 'h:mm a');
};

export const formatDateOnly = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  // Format: "Dec 15, 2024"
  return formatDate(date, 'MMM dd, yyyy');
};